// import { palette } from './palette';

export const typography = {
  fontFamily: 'Rubik',
};
